import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function HeaderNavigationItem({
  path = '',
  text = '',
  activePaths = [],
  activePrefixes = [],
  variant = '',
}) {
  const location = useLocation();
  const isActive =
    location.pathname === path
    || activePaths.includes(location.pathname)
    || activePrefixes.some((prefix) => location.pathname.startsWith(prefix));
  const linkClasses = [
    'header__navigation-item-link',
    isActive && 'header__navigation-item-link_active',
    variant === 'accent' && 'header__navigation-item-link_accent',
  ].filter(Boolean).join(' ');

  return (
    <li className="header__navigation-item">
      <Link
        to={path}
        className={linkClasses}
      >
        {text}
      </Link>
    </li>
  );
}
export default HeaderNavigationItem;
